




































import Vue from 'vue';
import { Geek } from '@/models';
import { typedStore } from '@/store';

export default Vue.extend({
  name: 'BasicAdminView',
  computed: {
    activeRouteName(): string {
      return this.$route.name || '';
    },
    currentGeek(): Geek {
      return typedStore(this).state.geek.current;
    },
  },
});
